import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS, ArcElement, Tooltip, Legend,
} from 'chart.js';
import styles from './Doughnut.module.css';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function DefaultDoughnut({ data, title, unit }) {

  const plugin = {
    id: 'emptyDoughnut',
    afterDraw(chart, args, options) {
      const {datasets} = chart.data;
      const {color, width, radiusDecrease} = options;
      let hasData = false;
  
      for (let i = 0; i < datasets.length; i += 1) {
        const dataset = datasets[i];
        hasData |= dataset.data.length > 0;
      }
  
      if (!hasData) {
        const {chartArea: {left, top, right, bottom}, ctx} = chart;
        const centerX = (left + right) / 2;
        const centerY = (top + bottom) / 2;
        const r = Math.min(right - left, bottom - top) / 2;
  
        ctx.beginPath();
        ctx.lineWidth = width || 2;
        ctx.strokeStyle = color || 'rgba(255, 128, 0, 0.5)';
        ctx.arc(centerX, centerY, (r - radiusDecrease || 0), 0, 2 * Math.PI);
        ctx.stroke();
      }
    }
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleFont: {
          size: 16
        },
        bodyFont: {
          size: 14
        },
      },
      emptyDoughnut: {
        color: '#F0F4FD',
        width: 80,
        radiusDecrease: 40
      },
    },
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.doughnut}>
          <div className={styles.doughnutWrapper}>
            <Doughnut 
              data={data} 
              options={options} 
              plugins={[plugin]} 
              style={{ width: '100%', height: '100%' }}
            />
          </div>
          <span className={styles.summary}>
            {title}
            <br />
            <br />
            <span className={styles.summary_num}>{data.summary}</span>
          </span>
        </div>
        <div className={styles.legendwrapper}>
          <div>
            {data?.labels?.map((elem, index) => (
              <div key={index} className={styles.countwrapper}>
                <div
                  className={styles.box}
                  style={{
                    backgroundColor: data.datasets[0].backgroundColor[index],
                  }}
                />
                <span
                  className={styles.text}
                >
                  {data?.datasets[0]?.data.length === 0 ? `0 ${unit}` : `${data?.datasets[0]?.data[index]} ${unit}`}
                </span>
                <span key={index} className={styles.label}>
                  {
                    data?.datasets[0]?.hasOwnProperty('dataPersons') ? 
                    `${elem} – ${data?.datasets[0]?.dataPersons[index]} чел.` : 
                    elem
                  }
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
